(function autoplayMediaController(root) {
  'use strict';

  function registerAutoplayMedia() {
    if (!root.Alpine) {
      return;
    }

    root.Alpine.data('autoplayMedia', () => ({
      motionQuery: null,
      motionChangeHandler: null,
      autoplayRequested: false,
      resumeAfterReduction: false,

      init() {
        this.autoplayRequested = Boolean(this.$el?.autoplay || this.$el?.hasAttribute?.('autoplay'));
        this.motionQuery = typeof root.matchMedia === 'function'
          ? root.matchMedia('(prefers-reduced-motion: reduce)')
          : null;
        this.motionChangeHandler = () => this.syncMotionPreference();

        if (typeof this.motionQuery?.addEventListener === 'function') {
          this.motionQuery.addEventListener('change', this.motionChangeHandler);
        } else if (typeof this.motionQuery?.addListener === 'function') {
          this.motionQuery.addListener(this.motionChangeHandler);
        }

        this.syncMotionPreference();
      },

      destroy() {
        if (typeof this.motionQuery?.removeEventListener === 'function') {
          this.motionQuery.removeEventListener('change', this.motionChangeHandler);
        } else if (typeof this.motionQuery?.removeListener === 'function') {
          this.motionQuery.removeListener(this.motionChangeHandler);
        }
      },

      syncMotionPreference() {
        const video = this.$el;

        if (!video || typeof video.pause !== 'function') {
          return;
        }

        if (this.motionQuery?.matches) {
          this.resumeAfterReduction = this.autoplayRequested;
          video.autoplay = false;
          video.pause();
          return;
        }

        if (!this.autoplayRequested) {
          return;
        }

        video.autoplay = true;

        if (this.resumeAfterReduction && typeof video.play === 'function') {
          const playback = video.play();
          playback?.catch?.(() => undefined);
        }

        this.resumeAfterReduction = false;
      },
    }));
  }

  if (root.document) {
    root.document.addEventListener('alpine:init', registerAutoplayMedia);

    if (root.Alpine) {
      registerAutoplayMedia();
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { registerAutoplayMedia };
  }
}(typeof window !== 'undefined' ? window : globalThis));
